import { DIRECTIONS } from 'common/constants';
import styled from 'styled-components';

export const StyledItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const StyledDiscountedPriceWrapper = styled.div`
  display: flex;
`;

export const StyledField = styled.div`
  text-transform: capitalize;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const StyledPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  direction: ${({ theme }) => (theme.direction === DIRECTIONS.RIGHT_TO_LEFT ? 'ltr' : 'rtl')};
`;

export const StyledOldPrice = styled.div`
  text-decoration: line-through;
  text-decoration-color: ${({ theme }) => theme.color.disabled};
`;
